<template>
  <b-form-group
    class="longtextfilter"
    :id="filterLabelId"
    :label="label"
    :label-for="filterId"
    data-test="outside-vif"
  >
    <div :id="filterWrapperId" class="longtextfilter-row">
      <div class="longtextfilter-col">
        <b-form-input
          v-if="useShortText"
          :id="filterId"
          :value="getValue?.value"
          @input="($e) => updateFilter({ value: $e, selected: !!selected })"
        />
        <b-form-textarea
          v-else
          :id="filterId"
          :value="getValue?.value"
          @input="($e) => updateFilter({ value: $e, selected: !!selected })"
          :placeholder="placeholder"
          rows="3"
        />
      </div>
      <div class="longtextfilter-col clear-filter">
        <filter-clear-button
          v-if="bindValue?.length > 0"
          @click="updateFilter('')"
        />
      </div>
    </div>
    <input
      type="checkbox"
      class="labeled-checkbox"
      :id="filterToggleLabelId"
      :checked="selected"
      @change="
        ($e) =>
          updateFilter({
            value: getValue.value,
            selected: $e.target.checked,
          })
      "
    />
    <label :id="filterToggleLabelId" :for="filterToggleId">Starts With</label>
  </b-form-group>
</template>

<script>
import FilterClearButton from "@/components/filters/FilterClearButton.vue";

export default {
  name: "LongTextFilter",
  components: { FilterClearButton },
  data() {
    return {
      filterText: "",
    };
  },
  props: {
    id: { type: String, default: "" },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    getValue: { type: [Object, String], default: null },
    storeWatch: { type: String, default: "" },
    filterAction: { type: String, default: "" },
    filterKey: { type: String, default: "" },
    updateMethod: { type: Function, default: () => {} },
    useShortText: { type: Boolean, default: false },
  },
  methods: {
    updateFilter({ value, selected }) {
      this.$emit("update-filter", {
        id: this.id,
        filterAction: this.filterAction,
        filterKey: this.filterKey,
        value,
        selected,
      });
      if (this.updateMethod) {
        return this.updateMethod({ value, selected });
      }
    },
    changeSelected($e) {
      this.updateFilter(this.getValue.value);
    },
  },
  computed: {
    bindValue: function () {
      let filterValue = this.getValue;
      if (this.$store.getters[this.storeWatch]) {
        filterValue = this.$store.getters[this.storeWatch];
      }
      return filterValue?.value ? filterValue.value : "";
    },
    filterId: function () {
      return this.id;
    },
    filterLabelId: function () {
      return this.id + "-label";
    },
    filterWrapperId: function () {
      return this.id + "-wrapper";
    },
    filterToggleLabelId: function () {
      return this.id + "-starts-with-label";
    },
    filterToggleId: function () {
      return this.id + "-starts-with";
    },
    selected() {
      const selectedValue = this.getValue?.selected || false;
      if (selectedValue === "false") {
        return false;
      }
      if (selectedValue === "true") {
        return true;
      }
      return selectedValue;
    },
  },
};
</script>

<style scoped>
.longtextfilter >>> fieldset {
  padding: 0;
  margin: 0.125rem 0 0 0;
}

.longtextfilter >>> .labeledcheckbox {
  display: flex;
}

.longtextfilter >>> .labeledcheckbox label {
  order: 2;
}

label {
  font-weight: 600;
}

.longtextfilter >>> div.longtextfilter-row {
  display: flex;
  flex-direction: row;
}

.longtextfilter >>> div.longtextfilter-col {
  display: flex;
  flex-direction: column;
  flex: 2;
  width: inherit;
}
.longtextfilter >>> div.clear-filter {
  flex: none;
  width: 2rem;
}
div.longtextfilter-col input {
  outline-offset: 4px;
  margin: 0.125rem 0.125rem 0.125rem 0;
  width: calc(12.5rem * 0.9);
}
</style>
